<template>
  <div class="card card-circle-chart" :data-background-color="color">

    <div class="card-header text-center">
      <h5 class="card-title">{{title}}</h5>
      <p class="description">{{description}}</p>
    </div>
    <div class="card-content text-center">
      <router-link v-bind:to="linkto">
        <div class="chart-circle oc-percent" :data-percent="percentage" ref="chart">{{percentage}}</div>
      </router-link>
    </div>

    <!--<div class="chart" data-percent="73">73%</div>-->

  </div>
</template>
<script>
  import EasyPieChart from 'easy-pie-chart'

  export default{
    name: 'circle-chart-card',
    props: {
      color: {
        type: String,
        default: 'blue'
      },
      percentage: {
        type: Number,
        default: 0
      },
      title: String,
      description: String,
      linkto: String,
    },
    data () {
      return {
        chartId: 'no-id',
        chart: null
      }
    },
    methods: {
      updateChartId () {
        var currentTime = new Date().getTime().toString()
        var randomInt = this.getRandomInt(0, currentTime)
        this.chartId = `div_${randomInt}`
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      renderChart (EasyPieChart) {
        /* eslint-disable no-new */
        this.chart = new EasyPieChart(this.$refs.chart, {
          lineWidth: 3,
          lineCap: 'round',
          size: 140,
          trackWidth: 6,
          scaleColor: false,
          scaleLength: 5,
          trackColor: 'rgba(225,225,225,.85)',
          barColor: '#FFFFFF',
          rotate: 0,
          animate: ({duration: 2000, enabled: true})
        })
      }
    },
    async mounted () {
      this.updateChartId()
      this.renderChart(EasyPieChart)
    },
    watch: {
      percentage: function (newVal) {
        if (this.chart) {
          this.chart.update(newVal)
        }
      }
    }
  }
</script>
<style>
  .oc-chart oc-canvas {
    position: absolute;
    top: 0;
    left: 0;
  }
  .oc-percent {
    display: inline-block;
    line-height: 110px;
    z-index: 2;
  }
  .oc-percent:after {
    content: '%';
    margin-left: 0.1em;
    font-size: .8em;
  }
  /*.oc-circle-chart {*/
    /*height:200px;*/
    /*width:200px;*/
    /*background-color: #18ce0f;*/
    /*margin:0;*/
    /*padding:0;*/
    /*border-radius: 50%;*/
  /*}*/
</style>
